import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

import {
    ChangeActNumberPayloadT,
    FTLGetCapacityResponseT,
    FTLGetCarTypesResponseT,
    FTLGetCommentsResponse,
    FTLGetDangerClassResponseT,
    FTLGetTransportTypesResponseT,
    FTLPrintTTNResponseT,
    UpdateFtlIntracityOrderPayload,
    UpdateFTLOrderPayloadI,
} from '../types/ftl.types'
import { FTLCreateAdditionalServicePayloadT } from '../types/additional_services.types'

export class FTLRepository {
    getCapacity(): Promise<AxiosResponse<FTLGetCapacityResponseT>> {
        return http.get('/cabinet/api/v2/ftl/cubature')
    }

    getComments(stateId: number): Promise<AxiosResponse<FTLGetCommentsResponse>> {
        return http.get('/cabinet/api/ftl/comments', { params: { stateId } })
    }

    getTransportTypes(): Promise<AxiosResponse<FTLGetTransportTypesResponseT>> {
        return http.get('/cabinet/api/ftl/transport-types')
    }

    getDangerClass(): Promise<AxiosResponse<FTLGetDangerClassResponseT>> {
        return http.get('/cabinet/api/danger-classes')
    }

    printTTN(id: number): Promise<AxiosResponse<FTLPrintTTNResponseT>> {
        return http.get(`/cabinet/api/v2/ftl/pdf/${id}`)
    }

    printRoute(order_id: number): Promise<AxiosResponse<any>> {
        return http.get(`/cabinet/api/ftl-orders/${order_id}/printout`, { responseType: 'blob' })
    }

    updateOrder(order_id: number, payload: UpdateFTLOrderPayloadI): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-order/${order_id}`, payload)
    }

    updateOrderLikeIntracity(
        order_id: number,
        payload: UpdateFtlIntracityOrderPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-order/${order_id}`, payload)
    }

    updateOrderIntracity(
        order_id: number,
        payload: UpdateFtlIntracityOrderPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-order/intracity/${order_id}`, payload)
    }

    changeActNumber(payload: ChangeActNumberPayloadT): Promise<AxiosResponse<void>> {
        return http.put('/cabinet/api/v2/admin/ftl-orders/mass-change-act-number', payload)
    }

    getCarTypes(): Promise<AxiosResponse<FTLGetCarTypesResponseT>> {
        return http.get('/cabinet/api/v2/ftl/car-types')
    }

    createAdditionalService(
        payload: FTLCreateAdditionalServicePayloadT
    ): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/v2/ftl/additional-service', payload)
    }

    uploadInvoiceDocument(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/cabinet/api/ftl-orders/upload-invoice-document', form_data)
    }

    deleteOrderAdditionalService(additional_service_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/v2/additional-service/${additional_service_id}`)
    }

    throwInBilling(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/v2/admin/ftl-orders/${id}/billing`, { id })
    }

    printFtlOrderInvoices(order_id: number): Promise<AxiosResponse<any>> {
        return http.get(`/print/api/ftl-order/${order_id}`, { responseType: 'blob' })
    }

    printFtlOrderStockDeliveryNoteInvoice(
        order_id: number,
        stock_delivery_note_index: number
    ): Promise<AxiosResponse<any>> {
        return http.get(`/print/api/ftl-order/${order_id}/${stock_delivery_note_index}`, {
            responseType: 'blob',
        })
    }

    uploadFtlStockScan(ftl_stock_id: number, form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(
            `/cabinet/api/v2/admin/ftl-stock/${ftl_stock_id}/upload-scan`,
            form_data
        )
    }

    uploadFtlOrderScan(ftl_order_id: number, form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(
            `/cabinet/api/v2/admin/ftl-orders/${ftl_order_id}/upload-scan`,
            form_data
        )
    }

    createLogisticBid(id: number, form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl/${id}/logistic-bid`, form_data)
    }
}
